module.exports = __webpack_public_path__ + "img/SRC-RKD-PLUS-front.8141d88c.jpg";